// @flow

import { useScreenWidth } from '@tectonics/hooks';

type DeviceType = 'mobile' | 'desktop';

export function useDeviceType(): DeviceType {
  const screenWidth = useScreenWidth();
  return screenWidth < 480
    ? 'mobile'
    : 'desktop';
}

export function useIsMobile(): bool {
  return useDeviceType() === 'mobile';
}
